import { render, staticRenderFns } from "./WidgetEntities.vue?vue&type=template&id=49637c5e&scoped=true&"
import script from "./WidgetEntities.vue?vue&type=script&lang=js&"
export * from "./WidgetEntities.vue?vue&type=script&lang=js&"
import style0 from "./WidgetEntities.vue?vue&type=style&index=0&id=49637c5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49637c5e",
  null
  
)

export default component.exports